import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';

import Home        from './pages/public/Home';
import GamesPage   from './pages/public/GamesPage';
import OffersPage  from './pages/public/OffersPage';
import PrivacyPage from './pages/public/PrivacyPage';
import SupportPage from './pages/public/SupportPage';

import Login    from './pages/Login';
import Register from './pages/Register';

import UserApp  from './pages/app/UserApp';
import AdminApp from './pages/app/AdminApp';
import SuperApp from './pages/app/SuperApp';

import './index.css';

const LoadingScreen = () => (
  <div style={{
    height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#080c14', color: '#f5a623',
    fontFamily: "'Rajdhani', sans-serif", fontSize: '22px', letterSpacing: '6px',
  }}>
    MegaFishHub
  </div>
);

const ProtectedRoute = ({ children, requiredPath }) => {
  const { user, loading, redirectTo } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  const dest = redirectTo || localStorage.getItem('blixo_redirect') || '/app';
  if (requiredPath && !dest.startsWith(requiredPath)) {
    return <Navigate to={dest} replace />;
  }
  return children;
};

const AuthRedirect = () => {
  const { user, redirectTo, loading } = useAuth();
  if (loading)    return <LoadingScreen />;
  if (!user)      return <Navigate to="/login" replace />;
  if (redirectTo) return <Navigate to={redirectTo} replace />;
  return <Navigate to="/app" replace />;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#0d1420', color: '#f5a623',
              border: '1px solid rgba(245,166,35,0.2)',
              fontFamily: "'Exo 2', sans-serif",
            },
          }}
        />
        <Routes>
          <Route path="/"        element={<Home />} />
          <Route path="/games"   element={<GamesPage />} />
          <Route path="/offers"  element={<OffersPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/support" element={<SupportPage />} />

          <Route path="/login"    element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/redirect" element={<AuthRedirect />} />

          <Route path="/app/*"   element={<ProtectedRoute requiredPath="/app"><UserApp /></ProtectedRoute>} />
          <Route path="/admin/*" element={<ProtectedRoute requiredPath="/admin"><AdminApp /></ProtectedRoute>} />
          <Route path="/super/*" element={<ProtectedRoute requiredPath="/super"><SuperApp /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
